import { useState, useEffect } from "react";
import { useSingleton } from "../../hooks/use-singleton";
import { useApi } from "../../hooks/use-api";
import {
  API_LEARNING_CREATE,
  API_USER_DASHBOARD,
  API_VIDEO_MARK,
  API_VIDEO_CHAT,
  apiGetLearningChallenge,
} from "../../utils/api-routes";
import { COOKIE_ACCESS_SUBSCRIBED_COURSES } from "../../utils/storage-constants";
import { hasCourseAccess } from "../../hooks/common/courses";

const useHandler = () => {
  const { role, user, mail, examType } = useSingleton();
  const { get, post } = useApi();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [learningRes, setLearningRes] = useState();
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const payload = {
          mail: mail,
        };
        const response = await post(API_USER_DASHBOARD, payload);
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (mail) {
      fetchDashboardData();
    }
  }, []);

  // const videoMarkCompleted = async (videoUrl) => {
  //   const payload = {
  //     user_email: mail,
  //     video_url: videoUrl,
  //     course_type: examType,
  //     filters: {},
  //   };
  //   try {
  //     const res = await post(API_VIDEO_MARK, payload);
  //     if (res.data) {
  //       console.log(res);
  //     }
  //   } catch (e) {
  //     console.log("ERROR COMES FROM VIDEO MARK COMPELETED", e);
  //   }
  // };

  const subscribedCourses = JSON.parse(
    localStorage.getItem(COOKIE_ACCESS_SUBSCRIBED_COURSES) || "[]",
  );

  const learningChallengeHistroy = async () => {
    try {
      const res = await get(apiGetLearningChallenge(mail));
      if (res) {
        const status = res?.data?.history?.[0]?.status === "INACTIVE";
        // setLearningChallenge(res?.data?.history || []);

        // Check current course subscription
        const hasAccess = hasCourseAccess(
          subscribedCourses,
          examType, // or currentCourse
        );

        if (role !== "guest" && hasAccess && status) {
          setShowGoalModal(true);
        } else {
          setShowGoalModal(false);
        }
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING CHALLENGE HISTROY API", e);
      setShowGoalModal(false);
    }
  };

  const learningChallengeCreate = async (goalDays) => {
    const payload = {
      email: mail,
      goal_period_days: Number(goalDays),
    };
    try {
      const res = await post(API_LEARNING_CREATE, payload);
      if (res) {
        setLearningRes(res?.data?.data);
        setShowGoalModal(false);
        setShowSuccessModal(true);
      }
    } catch (e) {
      console.log("EEROR COMES FROM LEARNING CHALLENGE CREARE API", e);
    }
  };

  const aiVideoChat = async (video_content, currentQuestion) => {
    const payload = {
      language: video_content?.language,
      filters: video_content,
      Question: currentQuestion,
    };

    try {
      const res = await post(API_VIDEO_CHAT, payload);
      if (res) {
        return res?.data; // ✅ return data so MediaPopup's videoRes useEffect works
      }
    } catch (e) {
      console.log("ERROR COMES FROM AI VIDEO CHAT API", e);
      return null;
    }
  };

  useEffect(() => {
    learningChallengeHistroy();
  }, []);

  return {
    user,
    dashboardData,
    loading,
    learningRes,
    showGoalModal,
    showSuccessModal,
    learningChallengeCreate,
    setShowGoalModal,
    setShowSuccessModal,
    // videoMarkCompleted,
    aiVideoChat,
  };
};

export default useHandler;
